'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildMessageDescriptorRecord;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _MessageDescriptor = require('../../records/MessageDescriptor');

var _MessageDescriptor2 = _interopRequireDefault(_MessageDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildMessageDescriptorRecord() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _pipe2.default)((0, _get2.default)('descriptor'), _MessageDescriptor2.default)(props);
}
module.exports = exports['default'];